import VesselData from "./data";

export default function vesselDataFromJson(json) {
  return new VesselData(
    json.id,
    json.theyr_id,
    json.company_id,
    json.description,
    json.imo_identifier,
    json.plugin,
    json.plugin_params,
    json.model_fouling,
    json.model_trim
  );
}
